module.exports = __webpack_public_path__ + "slick-ced611daf7709cc778da928fec876475.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./~/slick-carousel/slick/fonts/slick.eot
 ** module id = 1537
 ** module chunks = 0
 **/